import { Update } from "../components/rate-adjustment-case-merchant/Update";
import { Table } from "../components/rate-adjustment-case-merchant/Table";
import { SpaceBetween } from "@cloudscape-design/components-themed";

import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
　料率調整案件加盟店交渉履歴更新
 */
const RateAdjustmentCaseMerchantUpdate = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.RATE_SETTING);

  return (
    <SpaceBetween size="l">
      <Update />
      <Table />
    </SpaceBetween>
  );
};

export default RateAdjustmentCaseMerchantUpdate;
